import { DashboardFormWrapper } from '../dashboard';
import { ContainersPage } from './ContainersComponents';
import { ContainersOutHeader, ContainersOutForm } from './ContainersOutComponents';
import { RoleGuard } from '../../routes';

export const ContainersOut = () => {
  return (
    <RoleGuard roles={'admin'}>
      <ContainersPage>
        <ContainersOutHeader />
        <DashboardFormWrapper flow={'row'}>
          <ContainersOutForm />
          <ContainersOutHeader showOnlySubmit />
        </DashboardFormWrapper>
      </ContainersPage>
    </RoleGuard>
  );
};
